import { createQuery } from '@amzn/gsce-shared-react-lib';
import type {
  ListCategoriesRequest,
  ListCategoriesResponse,
} from 'src/types/helios/Category';
import { categoryService, withRetry } from '../index';
import { CategoryQueryKeys } from './keys';

/**
 * Query hook for listing categories scoped to a business unit.
 *
 * Uses the legacy REST `categoryService` (raw endpoint) rather than the typed
 * Helios SDK client: the categories API returns epoch-number timestamps
 * (`createdAt`, `lastUpdatedAt`) which fail the Smithy RFC-3339 deserializer —
 * the typed `ListCategoriesCommand` throws on deserialize, leaving the query
 * in `error` with `data === undefined` even though the HTTP call is 200. Same
 * reason `useQuestionQuery` wraps `questionService`.
 *
 * Categories are BU-scoped (matching the manual question flow, which lists all
 * BU categories); `divisionName` is a property on each category, not a list
 * filter. Callers own `enabled` gating on `businessUnitId`.
 */
export const useCategoriesQuery = createQuery<
  ListCategoriesRequest,
  ListCategoriesResponse
>(
  CategoryQueryKeys.list,
  (input: ListCategoriesRequest): Promise<ListCategoriesResponse> =>
    withRetry(() => categoryService.getAll(input)),
);
